import { render, staticRenderFns } from "./CatalogPlannerEditorDialog.vue?vue&type=template&id=111a1afa&scoped=true"
import script from "./CatalogPlannerEditorDialog.vue?vue&type=script&lang=js"
export * from "./CatalogPlannerEditorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111a1afa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('111a1afa')) {
      api.createRecord('111a1afa', component.options)
    } else {
      api.reload('111a1afa', component.options)
    }
    module.hot.accept("./CatalogPlannerEditorDialog.vue?vue&type=template&id=111a1afa&scoped=true", function () {
      api.rerender('111a1afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/fullscreen/CatalogPlannerEditorDialog.vue"
export default component.exports